import { render, staticRenderFns } from "./ListCompartilhamentoAppView.vue?vue&type=template&id=0bbca4ff&"
import script from "./ListCompartilhamentoAppView.vue?vue&type=script&lang=ts&"
export * from "./ListCompartilhamentoAppView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports